import { Component, ElementRef, forwardRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { ConciliationService } from 'app/core/services/conciliation.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-autocomplete-account-number',
  templateUrl: './autocomplete-account-number.component.html',
  styleUrls: ['./autocomplete-account-number.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutocompleteAccountNumberComponent),
      multi: true,
    }
  ],
})
export class AutocompleteAccountNumberComponent implements OnInit, ControlValueAccessor, OnDestroy {
  @ViewChild('accountNumberInput') accountNumberInput: ElementRef;
  accountForm: FormGroup;
  subscriptions: Subscription[] = [];
  showList: boolean;
  arrayCodeFilter = [];
  onChangeFn = (_: any) => { };
  onTouchedFn = (_: any) => { };

  constructor(private fb: FormBuilder,
    private conciliationService: ConciliationService
  ) {
    this.initForm();
  }

  ngOnInit() {
  }

  initForm(): void {
    this.accountForm = this.fb.group({
      account: ['', Validators.required]
    });
  }

  writeValue(value: any): void {
    if (value) {
      this.accountForm.patchValue({ account: value });
    } else {
      this.accountForm.patchValue({ account: '' });
    }
  }

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.accountForm.disable();
    } else {
      this.accountForm.enable();
    }
  }

  searchAccount(value: string): void {
    if (value) {
      const accountControl = this.accountForm.get('account');
      accountControl.patchValue(value);
      this.closeList();
      this.onChangeFn(value);
      this.accountNumberInput.nativeElement.focus();
    }
  }

  closeList(): void {
    this.showList = false;
  }

  onAutoComplete(val: any): void {
    if (val) {
      this.conciliationService.getAccountNumber({ filter: val })
      .subscribe({
        next: (resp) => {
          if (resp) {
            this.arrayCodeFilter = [];
            this.showList = true;
            this.arrayCodeFilter = resp;
          }
        }
      });
    } else {
      this.arrayCodeFilter = [];
      this.onChangeFn(val);
    }
    const regVal = val !== null ? val.trim() : null;
    this.onChangeFn(regVal);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscribe: Subscription) => subscribe.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/autocomplete-account-number/autocomplete-account-number.component.ts